export default __webpack_public_path__ + "static/media/production-board.102b0095.svg";